import React from "react";
import CustomModal from "../../../../../components/CustomModal";
import { IOperacoesPatioCancela } from "../types/types";
import Form from "./Form";

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  isSpe?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: IOperacoesPatioCancela;
}


const CreateOperacaoPatioCancela: React.FC<Props> = (props: Props) => {

  return (
    <CustomModal title={props.isEdit ? (props.isSpe ? "Editar Cancela SPE" : "Editar Cancela") : (props.isSpe ? "Cadastrar Cancela SPE" : "Cadastrar Cancela")} onClose={props.onClear}>
      <Form isView={props.isView} isSpe={props.isSpe} selectedRow={props.selectedRow} onConfirm={props.onConfirm} isEdit={props.isEdit} onClose={props.onClear} />
    </CustomModal>
  )
};

export default CreateOperacaoPatioCancela;
